// extracted by mini-css-extract-plugin
export default {"box":"HistoryCard_box__6-UMr"};